import React,{useEffect,useState, useRef } from 'react';
import Axios from '../../lib/axios/axiosInstance';
import { Container, Row, Col, Tab, Form } from "react-bootstrap";
import { Link } from 'react-router-dom';
import * as AuthVerify from '../../lib/common';
import { Flip, Slide, toast } from 'react-toastify';
import { useParams , useSearchParams,useNavigate } from "react-router-dom";
import "./CostCenterDetails.styles.css";
import { CheckBox } from "@material-ui/icons";
import SlectInputField from "../SlectInputField";
import Modal from 'react-bootstrap/Modal';
import { Formik } from "formik";
import * as Yup from "yup";
import InputField from "../InputField/InputField";

const CostCenterDetails = () => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [ccnum, setCcName] = useState(false);
    const [costCenterDetails, setCostCenterDetails] = useState(false);
    const [userDetails, setUserDetails] = useState(false);
    const [costCenterCatalog, setCostCenterCatalog] = useState(false);
    const [newCostCenterCatalog, setNewCostCenterCatalog] = useState(false);

    const [selectedCostCenterCatalog, setSelectedCostCentercatalog] = useState(false);
    const [dmShow, setDmShow] = useState(false);
    const [emShow, setEmShow] = useState(false);
    const [asEmShow, setAsEmShow] = useState(false);

    const [staffs, setStaffs] = useState([]);
    const [approvalSettings, setApprovalSettings] = useState([]);
    const [totalApprovalSetting, setTotalApprovalSetting] = useState(0);
    const [selectedApprovalSettingData, setSelectedApprovalSettingData] = useState(false);

    const [approvalPurchasers, setApprovalPurchasers] = useState([]);
    const [totalApprovalPurchasers, setTotalApprovalPurchasers] = useState(0);

    const getStaffs = async () => {
      // userDetails.arnum="ARM-90212518";
      await Axios.get(`/corporate/user/${AuthVerify.getUser().arnum}`)
      .then(async (data) => {
        var dd=[];
          if( data.data?.data && data.data?.data?.users.length >0){
            // dd.push({ label: 'Select an option', value:  null})
            data.data.data.users.forEach(element => {
              dd.push({ label: element.firstname +" "+element.lastname, value:  element.username})
          });
          setStaffs(dd);
        }
      })
    }

    const getCostCenterDetails = async () => {
        await Axios.get(`/corporate/costcenter/${AuthVerify.getUser().arnum}/${ccnum}`)
        .then(function (response) {
            if (response && response.data?.data) {
              setCostCenterDetails(response.data.data.costcenter);
              setCostCenterCatalog(response.data.data.catalogs);
              setApprovalSettingsData(response.data.data.costcenter);
              setApprovalPurchasers(response.data.data.purchasers??[]);
            }
            else {
              navigate('/');
            }
        })
        .catch(function (error) {
          navigate('/');
        });
    };

    const setApprovalSettingsData = (aSetting) => {
      var approvalSettingsData=[];
      approvalSettingsData.push({lvl:approvalSettingsData.length,readOnly:true,maxAmount:aSetting.appr_0_maxamt});
      approvalSettingsData.push({lvl:approvalSettingsData.length,readOnly:true,maxAmount:aSetting.appr_1_maxamt,appr:aSetting.appr_1,apprs:aSetting.appr_1s});
      approvalSettingsData.push({lvl:approvalSettingsData.length,readOnly:true,maxAmount:aSetting.appr_2_maxamt,appr:aSetting.appr_2,apprs:aSetting.appr_2s});
      approvalSettingsData.push({lvl:approvalSettingsData.length,readOnly:true,maxAmount:aSetting.appr_3_maxamt,appr:aSetting.appr_3,apprs:aSetting.appr_3s});
      setApprovalSettings(approvalSettingsData);
      setTotalApprovalSetting(approvalSettingsData.length);
    }

    async function getNewCostCenterCatalog () {
      await Axios.get(`/corporate/costcentercatalog/${AuthVerify.getUser().arnum}/${ccnum}/new`)
      .then(async (catalogs) => {
          var dd=[];
          if(catalogs?.data?.data?.catalogs){
            catalogs?.data?.data?.catalogs.forEach(element => {
              dd.push({ label: element.catalogname, value:  element.catalognum})
          });
          setNewCostCenterCatalog(dd)
        }else{
          setNewCostCenterCatalog([])
        }
        setEmShow(true);
      })
  }

  async function addCostCenterCatalog (values) {
    await Axios.post(`/corporate/costcentercatalog/${AuthVerify.getUser().arnum}/${ccnum}`,{
      "catalog": {
        "catalognum": values.catalognum
      }
    })
    .then(async (catalogs) => {
      setCostCenterCatalog(catalogs?.data?.data?.catalogs);
      toast.success('New cost center added successfully', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
          transition: Slide,
      });
      setEmShow(false);
    })
  }

  async function deleteCostCenterCatalog () {
    if(selectedCostCenterCatalog){
      await Axios.delete(`/corporate/costcentercatalog/${AuthVerify.getUser().arnum}/${ccnum}/${selectedCostCenterCatalog}`)
      .then(async (catalogs) => {
        setCostCenterCatalog(catalogs?.data?.data?.catalogs);
        toast.success('Cost center deleted successfully', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
        });
        setDmShow(false);
      })
    }
  }

  useEffect(async () => {
    if(searchParams.get("ccnum"))setCcName(searchParams.get("ccnum"));
  }, [searchParams])

  useEffect(async () => {
    if(ccnum){getCostCenterDetails();getStaffs();}
  }, [ccnum])
    
  const addNewApprovalSetting = () => {
    approvalSettings.push({lvl:approvalSettings.length,readOnly:false,maxAmount:0,appr:null,apprs:null});
    setApprovalSettings(approvalSettings);
    setTotalApprovalSetting(approvalSettings.length);
  }

  const deleteApprovalSetting = (lvl) => {
    var data=approvalSettings.filter(x=>x.lvl!=lvl);
    setApprovalSettings(data);
    setTotalApprovalSetting(data.length);
  }

  const changeApprovalSettingValue = (lvl,param,value) => {
    approvalSettings.map(item=>{
      if(item.lvl==lvl){
        item[param]=value;
      }
    })
    setApprovalSettings(approvalSettings);
    setTotalApprovalSetting(approvalSettings.length+1);
    // console.log(approvalSettings);
  }

const saveApprovalSetting = async () => {
  var jsondata={costcenter:{}}
  approvalSettings.map((item,i)=>{
    jsondata.costcenter[`appr_${i}_maxamt`]=item.maxAmount;
    if(i>0){
      jsondata.costcenter[`appr_${i}`]=item.appr;
      jsondata.costcenter[`appr_${i}s`]=item.apprs;
    }
  });
  // https://devb2b.bizpoint-intl.com:3082/api/corporate/costcenter/:arnum/:ccnum
  await Axios.post(`/corporate/costcenter/${AuthVerify.getUser().arnum}/${ccnum}`,jsondata)
  .then(async (data) => {
    setApprovalSettingsData(data.data.data.costcenter);
    setAsEmShow(false);
    toast.success('Updated successfully.', {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 5000,
      transition: Slide,
    });
  })
}

const addPurchaser = async () => {
  var jsondata={purchaser:{}}
  approvalPurchasers.map((item,i)=>{
      jsondata.purchaser[`username`]=item.username;
  });
  // https://devb2b.bizpoint-intl.com:3082/api/corporate/costcenterpurchaser/:arnum/:ccnum
  await Axios.post(`/corporate/costcenterpurchaser/${AuthVerify.getUser().arnum}/${ccnum}`,jsondata)
  .then(async (data) => {
    setApprovalPurchasers(data.data.data.purchasers);
    toast.success('Purchaser added successfully.', {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 5000,
      transition: Slide,
    });
  }).catch(error => {
    console.log(error.message);
    toast.error('Purchaser added failed.', {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 5000,
      transition: Slide,
    });
  })
}
const addNewApprovalPurchaser = () => {
  approvalPurchasers.push({lvl:approvalPurchasers.length+1,readOnly:false,username:null});
  setApprovalPurchasers(approvalPurchasers);
  setTotalApprovalPurchasers(approvalPurchasers.length);
}
const changeApprovalPurchaserValue = (lvl,value) => {
  approvalPurchasers.map(item=>{
    if(item.lvl==lvl){
      item.username=value;
    }
  })
  setApprovalPurchasers(approvalPurchasers);
  setTotalApprovalPurchasers(approvalPurchasers.length);
  // console.log(approvalPurchasers);
}
const removePurchaser = async (uuid) => {
  // https://devb2b.bizpoint-intl.com:3082/api/corporate/costcenterpurchaser/:arnum/:ccnum/:uuid
  await Axios.delete(`/corporate/costcenterpurchaser/${AuthVerify.getUser().arnum}/${ccnum}/${uuid}`)
  .then(async (data) => {
    setApprovalPurchasers(data.data.data.purchasers??[]);
    toast.success('Purchaser removed successfully.', {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 5000,
      transition: Slide,
    });
  })
}
const setSelectedApprovalSetting = (lvl) => {
  var data = approvalSettings.filter(x=>x.lvl==lvl)[0];
  setSelectedApprovalSettingData(data);
  setAsEmShow(true);
}

const ApprovalSetting =(props) => {
  if(props.item){
    if(props.item.lvl==0){
      return (
        <Formik>
            {() => (
            <Row style={{display: "flex", margin:"auto"}}>
              <div className='col-md-2' style={{margin:"auto 5px"}}>{props.item?.lvl!=0?`Level ${props.item.lvl}`: `Skip Approval`}</div>
              <div className='col-md-2'>
                <InputField Name={`appr_${props.item.lvl}_maxamt`} id={`appr_${props.item.lvl}_maxamt`} ReadOnly={props.item.readOnly??false} value={props.item.maxAmount} onChange={(e)=>changeApprovalSettingValue(props.item.lvl,'maxAmount',e.target.value)} Labels="Amount Limit" Type="number" />
              </div>
              <div className='col-md-3'>
              </div>
              <div className='col-md-3'>
              </div>
              <div className='col-md-2' style={{margin:"auto 5px"}}>
              {AuthVerify.getPermissions("CostCenter")?.edit && <button className='btn btn-sm' style={{background:"none", color:"blue"}} onClick={()=>setSelectedApprovalSetting(props.item.lvl)}>Edit</button>}
              {/* <button className='btn btn-sm' style={{background:"none", color:"blue"}} onClick={()=>deleteApprovalSetting(props.item.lvl)}>Remove</button> */}
              </div>
            </Row>
            )}
        </Formik>
      )
    }
    else{
      return (
        <Formik>
            {() => (
            <Row style={{display: "flex", margin:"auto"}}>
              <div className='col-md-2' style={{margin:"auto 5px"}}>{props.item?.lvl!=0?`Level ${props.item.lvl}`: `Minimum`}</div>
              <div className='col-md-2'>
                <InputField Name={`appr_${props.item.lvl}_maxamt`} id={`appr_${props.item.lvl}_maxamt`} ReadOnly={props.item.readOnly??false} defaultValue={props.item.maxAmount} onChange={(e)=>changeApprovalSettingValue(props.item.lvl,'maxAmount',e.target.value)} Labels="Amount Limit" Type="number" />
              </div>
              <div className='col-md-3'>
                {props.item?.readOnly ? 
                <InputField Name={`appr_${props.item.lvl}`} id={`appr_${props.item.lvl}`} ReadOnly={props.item.readOnly??false} value={props.item.appr} Labels="Approver(s)" Type="text" />
                :
                <SlectInputField Name={`appr_${props.item.lvl}`} id={`appr_${props.item.lvl}`} ReadOnly={props.readOnly??false} Labels="Approver"
                  placeHolder="Select an option" options={staffs} onChange={(e)=>changeApprovalSettingValue(props.item.lvl,'appr',e.target.value)}/>}
              </div>
              <div className='col-md-3'>
                {props.item?.readOnly ? 
                <InputField Name={`appr_${props.item.lvl}s`} id={`appr_${props.item.lvl}s`} ReadOnly={props.item.readOnly??false} value={props.item.apprs} Labels="Backup Approver(s)" Type="text" />
                :
                <SlectInputField Name={`appr_${props.item.lvl}s`} id={`appr_${props.item.lvl}s`} ReadOnly={props.readOnly??false} Labels="Backup Approver"
                  placeHolder="Select an option" options={staffs} onChange={(e)=>changeApprovalSettingValue(props.item.lvl,'apprs',e.target.value)}/>}
              </div>
              <div className='col-md-2' style={{margin:"auto 5px"}}>
                {props.item.readOnly ? 
                
                <>
                {AuthVerify.getPermissions("CostCenter")?.edit &&<button className='btn btn-sm' style={{background:"none", color:"blue"}} onClick={()=>setSelectedApprovalSetting(props.item.lvl)}>Edit</button>}
                {/* <button className='btn btn-sm' style={{background:"none", color:"blue"}} onClick={()=>deleteApprovalSetting(props.item.lvl)}>Remove</button> */}
                </>:
                <>{AuthVerify.getPermissions("CostCenter")?.edit &&<button className='btn btn-sm' style={{background:"none", color:"blue"}} onClick={()=>setSelectedApprovalSetting(props.item.lvl)}>Save</button>}</>}

              </div>
            </Row>
            )}
          </Formik>
      )
    }
    
  }else{
    return (<></>)
  }
  
}

const Purchasers =(props) => {
  if(props.item && staffs.length>0){
    if(props.item.uuid){
      var staffName=staffs.filter(x=>x.value==props.item.username)[0];
      return (<Formik>
        {() => (
        <Row style={{display: "flex", margin:"auto"}}>
            {/* <div className='col-md-2' style={{margin:"auto 5px"}}>Minimum</div> */}
            <div className='col-md-4'>
            <InputField Name={`username${props.item.username}`} id={`username${props.item.username}`} ReadOnly={true} value={staffName?.label} Labels="Name" Type="text" />
            </div>
            {AuthVerify.getPermissions("CostCenter")?.edit && false &&
            <div className='col-md-2' style={{margin:"auto 5px"}}>
             <button className='btn btn-sm' style={{background:"none", color:"blue"}} onClick={()=>removePurchaser(props.item.uuid)}>Remove</button>
            </div>}
          </Row>
          )}
        </Formik>)
    }
    else{
      var username=staffs.filter(x=>x.value==props.item.username);
      return (<Formik>
        {() => (
        <Row style={{display: "flex", margin:"auto"}}>
            {/* <div className='col-md-2' style={{margin:"auto 5px"}}>Minimum</div> */}
            <div className='col-md-4'>
                
                <SlectInputField Name={`appr_${props.item.lvl}s`} id={`appr_${props.item.lvl}s`} ReadOnly={props.readOnly??false} Labels="Name"
                  placeHolder="Select an option" options={staffs} onChange={(e)=>changeApprovalPurchaserValue(props.item.lvl,e.target.value)}/>
            
            </div>
            {AuthVerify.getPermissions("CostCenter")?.edit && 
            <div className='col-md-2' style={{margin:"auto 5px"}}>
                <button className='btn btn-sm' style={{background:"none", color:"blue"}} onClick={()=>addPurchaser(props.item.lvl)}>Save</button>

            </div>}
          </Row>
          )}
        </Formik>)
    }
    
  }else{
    return (<></>)
  }
}
    
  return (
    <>
    <section className="main-container col1-layout">
            <div className="main">
                <div className="col-main">
                    <div className="shopping-cart-inner">
                        <div className="page-content">
                            <div className="page-content checkout-page">
                                <div className="box-border" style={{margin:"auto", maxWidth:"80%"}}>
                                    <h2>Cost Center Details</h2>

                                    {/* <h3 className="checkout-sep" style={{ paddingBottom: "0" }}>No. PES000005983</h3> */}
                                    <h5><strong>Cost Center Code :</strong> {costCenterDetails.ccnum}</h5>
                                    <h5><strong>Description:</strong> {costCenterDetails.ccname}</h5>
                                    <h5><strong>Budget:</strong> $0.0</h5>
                                    <div className="box-account" style={{ display: "grid" }}>
                                    <div className="page-title">
                                        <Col sm={12} style={{padding:"5px 0px 10px 0px"}}>
                                            <h2 style={{float:"left"}}>1. Catalog</h2>
                                            {AuthVerify.getPermissions("CostCenter")?.edit && <button style={{float:"right", textDecoration:"none",marginLeft:"20px", fontWeight:"bold"}}  onClick={()=>getNewCostCenterCatalog()}>+ Add New Catalog</button>}
                                        </Col>
                                      </div>
                                      <div className="header-nav-dropdown-wrapper header-nav-dropdown-wrapper-1">
                                        {costCenterCatalog ? 
                                        costCenterCatalog.map((item,i)=>{
                                          return (
                                          <>
                                          {AuthVerify.getPermissions("CostCenter")?.edit ?
                                          <Link 
                                          key={i}
                                          to={`/catalog-details?catalognum=${item.catalognum}`}
                                          className="jtv-custom-box"
                                          style={{ width: "20%", border: "1px #5aa0dd solid", height: "100px" }}
                                        >
                                          <h5 className="heading">
                                            <i
                                              className="fa fa-clipboard"
                                              style={{
                                                fontSize: "20px",
                                                padding: "0",
                                                marginTop: "20px",
                                                border: "0",
                                                background: "transparent",
                                              }}
                                            ></i>{" "}
                                            {item.catalogname}
                                          </h5>
                                          <small style={{marginTop:"15px"}}>
                                          {AuthVerify.getPermissions("CostCenter")?.edit && <Link to={`/catalog-details?catalognum=${item.catalognum}`}>Edit</Link>} {" "} {AuthVerify.getPermissions("CostCenter")?.edit && <Link to="#" onClick={()=>{setSelectedCostCentercatalog(item.catalognum); setDmShow(true);}} style={{color:"red"}}>Delete</Link>}<br/>
                                          </small>
                                        </Link>:
                                        <div 
                                        key={i}
                                        className="jtv-custom-box"
                                        style={{ width: "20%", border: "3px #5aa0dd solid" }}
                                      >
                                        <h5 className="heading">
                                          <i
                                            className="fa fa-clipboard"
                                            style={{
                                              fontSize: "20px",
                                              padding: "0",
                                              marginTop: "20px",
                                              border: "0",
                                              background: "transparent",
                                            }}
                                          ></i>{" "}
                                          {item.catalogname}
                                        </h5>
                                        <small style={{marginTop:"15px"}}>
                                        {AuthVerify.getPermissions("CostCenter")?.edit && <Link to={`/catalog-details?catalognum=${item.catalognum}`}>Edit</Link>} {" "} {AuthVerify.getPermissions("CostCenter")?.edit && <Link to="#" onClick={()=>{setSelectedCostCentercatalog(item.catalognum); setDmShow(true);}} style={{color:"red"}}>Delete</Link>}<br/>
                                        </small>
                                      </div>
                                          }
                                          </>)
                                        }):
                                          <Col sm={12} style={{textAlign:"center"}}>No Catalog Found !</Col>
                                        }
                                      </div>
                                    </div>
                                    <br />
                                    <>
                                    <div className="box-account" style={{ display: "grid" }}>
                                      <div className="toolbar">
                                        <div className="row">
                                          <div className="col-md-12 col-sm-12" style={{display: "flex"}}>
                                            <h2
                                              style={{fontSize: "16px" , letterSpacing: "1px", marginTop: "0",textTransform: "uppercase", marginBottom: "auto", fontWeight: "700"}}>
                                              2. Approval Settings</h2>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="box-account" style={{ display: "grid" }}>
                                      <div className="header-nav-dropdown-wrapper">
                                        {staffs && approvalSettings.map((item,i)=>{
                                          return <ApprovalSetting item={item} key={i}/>
                                        })}
                                        {approvalSettings && approvalSettings.leng}
                                        {/* <Row style={{paddingTop:"25px"}}>
                                          <div className="col-md-6 text-left">
                                            <button style={{background:"none", color:"blue"}} onClick={()=>addNewApprovalSetting()}>+ Add Approval
                                              Level</button>
                                          </div>
                                          <div className="col-md-6 text-right">
                                            <button className='button btn-proceed-checkout' style={{padding:"7px 10px"}}
                                              onClick={()=>saveApprovalSetting()}>Save</button>
                                          </div>
                                        </Row> */}
                                      </div>
                                    </div>
                                  </>

                                  <>
                                    <div className="box-account" style={{ display: "grid" }}>
                                      <div className="toolbar">
                                        <div className="row">
                                          <div className="col-md-12 col-sm-12" style={{display: "flex"}}>
                                            <h2
                                              style={{fontSize: "16px" , letterSpacing: "1px", marginTop: "0",textTransform: "uppercase", marginBottom: "auto", fontWeight: "700"}}>
                                              3. Purchasers</h2>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div  style={{ display: "grid" }}>
                                      <div className="header-nav-dropdown-wrapper">
                                        {staffs && approvalPurchasers.map((item,i)=>{
                                          return <Purchasers item={item} key={i}/>
                                        })}
                                        {AuthVerify.getPermissions("CostCenter")?.edit && false &&
                                        <Row style={{paddingTop:"25px"}}>
                                          <div className="col-md-6 text-left">
                                            <button style={{background:"none", color:"blue"}} onClick={()=>addNewApprovalPurchaser()}>+ Add
                                              Purchasers</button>
                                          </div>
                                        </Row>
                                        }
                                      </div>
                                    </div>
                                  </>
                                  <div className="cart_navigation">
                                        <button className="button btn-proceed-checkout" title="Proceed to Checkout" type="button" onClick={()=>navigate('/my-account?activeKey=Cost')}><span>Back to My Cost Center</span></button>
                                  </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            
      <Modal show={dmShow} dialogClassName="modal-90w" animation={false} fade={false} style={{opacity:1}} onHide={()=>setDmShow(false)}>
        <Modal.Header closeButton={false}>
          <Modal.Title>Delete Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure about the delete ?
        </Modal.Body>
        <Modal.Footer>
        <button
              className="button btn-primary"
              title="Proceed to Checkout"
              type="button"
              onClick={()=>deleteCostCenterCatalog()}
              style={{
                marginRight: "10px",
                padding: "10px"
              }}
              >
            <span>Confirm</span>
          </button>
          <button
            className="button btn-danger"
            title="Proceed to Checkout"
            type="button"
            onClick={()=>setDmShow(false)}
            style={{
              marginRight: "10px",
              padding: "10px"
            }}
          >
            <span>Close</span>
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={emShow} dialogClassName="modal-90w" animation={false} fade={false} style={{opacity:1}} onHide={()=>setEmShow(false)}>
        <Modal.Header closeButton={false}>
          <Modal.Title>Create New Cost Center Catalog</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Formik
          initialValues={{catalognum:''}}
          validationSchema={Yup.object().shape({
            catalognum: Yup.string().min(2).required("Catalog name is required"),
          })}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            setSubmitting(false);
            addCostCenterCatalog(values);
          }}
          enableReinitialize
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              errors, touched
            } = props;
            return (
              <Form onSubmit={handleSubmit}>
                <div className="box-border">
                  <div className="form-list">
                      
                      <Row>
                        <Col xl={12} sm={12}>
                          <Row>
                            <Col xl={12} sm={12}>
                            <SlectInputField
                                    Labels="Catalog Name"
                                    Name="catalognum"
                                    placeHolder="Select Your Catalog"
                                    options={newCostCenterCatalog}
                                    value={values.catalognum}
                                    onChange={e=>{handleChange(e); }}
                                    onBlur={handleBlur}
                                    className={
                                      (errors.catalognum && touched.catalognum
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                            </Col>
                          </Row>
                        </Col>
                        
                      </Row>
                  </div>
                </div>
                <Row>
                <div className="cart_navigation">
                  <button
                    className="button btn-proceed-checkout btn-danger"
                    title="Proceed to Checkout"
                    type="button"
                    onClick={() => setEmShow(false)}
                    style={{
                      marginRight: "10px",
                      padding: "10px"
                    }}
                  >
                    <span>Close</span>
                  </button>

              
                    <button
                      className="button btn-proceed-checkout"
                      title="Proceed to Checkout"
                      type="submit"
                      style={{
                        marginRight: "10px",
                        background: "#337ab7",
                        border: "0px solid #337ab7",
                        padding: "10px"
                      }}
                    >
                      <span>Create</span>
                    </button>
                </div>
                
                </Row>
              </Form>
            );
          }}
        </Formik>
        </Modal.Body>
      </Modal>

      <Modal show={asEmShow} size="lg" dialogClassName="modal-90w" centered={true} animation={false} fade={false} style={{opacity:1}} onHide={()=>setAsEmShow(false)}>
        <Modal.Header closeButton={false}>
          <Modal.Title>Update Cost Center</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik>
            {() => (
            <Row style={{display: "flex", margin:"auto"}}>
              <div className='col-md-2' style={{margin:"auto 5px"}}>{selectedApprovalSettingData.lvl==0? `Skip Approval` :`Level ${selectedApprovalSettingData.lvl}`}</div>
              <div className='col-md-3'>
                <InputField Name={`appr_${selectedApprovalSettingData.lvl}_maxamt`} defaultValue={selectedApprovalSettingData.maxAmount} onChange={(e)=>changeApprovalSettingValue(selectedApprovalSettingData.lvl,'maxAmount',e.target.value)} Labels="Amount Limit" Type="number" />
              </div>
              {/* <div className='col-md-3'>
                {selectedApprovalSettingData.lvl!=0 && 
                <SlectInputField Name={`appr_${selectedApprovalSettingData.lvl}`} Labels="Approver" value={selectedApprovalSettingData.appr}
                  placeHolder="Select an option" options={staffs} onChange={(e)=>changeApprovalSettingValue(selectedApprovalSettingData.lvl,'appr',e.target.value)}/>
                }
              </div>
              <div className='col-md-3'>
                {selectedApprovalSettingData.lvl!=0 && 
                  <SlectInputField Name={`appr_${selectedApprovalSettingData.lvl}s`}  Labels="Backup Approver" value={selectedApprovalSettingData.apprs}
                    placeHolder="Select an option" options={staffs} onChange={(e)=>changeApprovalSettingValue(selectedApprovalSettingData.lvl,'apprs',e.target.value)}/>
                }
              </div> */}
              {/* <div className='col-md-2' style={{margin:"auto 5px"}}>
                <button className='btn btn-sm' style={{background:"none", color:"blue"}} onClick={()=>setSelectedApprovalSetting(selectedApprovalSettingData.lvl)}>Edit</button>
                <button className='btn btn-sm' style={{background:"none", color:"blue"}} onClick={()=>deleteApprovalSetting(selectedApprovalSettingData.lvl)}>Remove</button>
              </div> */}
            </Row>
            )}
          </Formik>
        </Modal.Body>
        <Modal.Footer>
         <div className="">
            <button
              className="button btn-proceed-checkout btn-danger"
              title="Proceed to Checkout"
              type="button"
              onClick={() => setAsEmShow(false)}
              style={{
                marginRight: "10px",
                padding: "10px"
              }}
            >
              <span>Close</span>
            </button>
            <button
                className="button btn-proceed-checkout"
                title="Proceed to Checkout"
                type="button"
                onClick={()=>saveApprovalSetting()}
                style={{
                  marginRight: "10px",
                  background: "#337ab7",
                  border: "0px solid #337ab7",
                  padding: "10px"
                }}
              >
                <span>Update</span>
              </button>
          </div>
        </Modal.Footer>
      </Modal>

        </section >
    </>
    
  );
};

export default CostCenterDetails;
